import { useCallback } from 'react';
import { ImageGallery } from './viewers/ImageGallery';
import { triggerDownload } from '@/utils/download';

interface ImageViewerProps {
  src: string;
  alt: string;
  onClose: () => void;
}

/**
 * Thin wrapper around ImageGallery for backward compatibility.
 * All chat image viewers, favorites, pinned messages, etc. use this component.
 * Provides download capability for chat/DM images.
 */
export function ImageViewer({ src, alt, onClose }: ImageViewerProps) {
  const handleDownload = useCallback(() => {
    triggerDownload(src, alt || 'image');
  }, [src, alt]);

  return (
    <ImageGallery
      images={[{ url: src, title: alt }]}
      onClose={onClose}
      onDownload={handleDownload}
    />
  );
}
